//Notification Types ('success' | 'info' | 'warning' | 'error' | 'blank')
export enum NotificationTypes {
  SUCCESS = 'success',
  INFO = 'info',
  WARNING = 'warning',
  ERROR = 'error'
}
